<script>
//
export let pageCopy;
export let pageTitle;
let theTitle;

if (pageTitle !== null) {
    theTitle = pageTitle;

} else {
    theTitle = "";
}
//
// console.log("feature one is go");
</script>
<section>
	<div class="banner-two">
    {#if theTitle !== ""}
    	<h2>{@html pageTitle}</h2>
    {/if }
    <!-- <div>
        <p>{@html pageCopy}</p>
    </div> -->
</div>
</section>